// extracted by mini-css-extract-plugin
var _1 = "puNRz";
var _2 = "JxQ4V";
var _3 = "IiEZa";
var _4 = "ibv_Y";
var _5 = "otBAK";
var _6 = "WiBpn";
export { _1 as "base", _2 as "icon", _3 as "title", _4 as "total", _5 as "trendDiff", _6 as "trendIcon" }
